import dayjs from "dayjs";
import i18next, { DEFAULT_LOCALE, Locale, LOCALES } from "../i18n/config";

const setLocale = async (locale: Locale) => {
  dayjs.locale(locale);
  await i18next.changeLanguage(locale);
  localStorage.setItem("locale", locale);
};

export default function useLocale() {
  return {
    locale: getLocale(),
    setLocale,
  };
}

export function getLocale(): Locale {
  const i18Locale = i18next.language;

  return LOCALES.includes(i18Locale as Locale)
    ? (i18Locale as Locale)
    : DEFAULT_LOCALE;
}
